import { useMutation, useQuery } from '@apollo/client';
import { preofferSelectedQuery } from '../apollo/cache/localQuery';
import useSnackBars from './useSnackBars';
import useSelectedCompany from './useSelectedCompany';
import { getLocalStorageVariable } from '../apollo/helpers/local-storage';
import REQUEST_PRE_OFFERS_EVALUATION from '../graphql/mutations/request-preoffer-evaluation';
import { GTM_EVENTS } from '../constants/tag-manager-events';
import { pushCompanyConversionEvent } from '../helpers/tag-manager';
import {
  getErrorCodeFromExtensions,
  getDebtorNamesFromExtensions,
  isCreditLineError,
} from '../constants/credit-line-error-config';

const useEvaluatePreoffers = (onCompleted = () => null, onCreditLineError = () => null) => {
  const { addAlert } = useSnackBars();
  const company = useSelectedCompany();
  const requestingPlatformId = getLocalStorageVariable('requestingPlatformIdVar');
  const { data: { selectedPreofferIds } } = useQuery(preofferSelectedQuery);
  const [requestPreoffer, { loading }] = useMutation(REQUEST_PRE_OFFERS_EVALUATION, {
    variables: {
      requestingPlatformId,
      invoiceIds: selectedPreofferIds,
    },
    onCompleted: (data) => {
      const warningCode = data?.requestPreOfferEvaluation?.warningCode;
      pushCompanyConversionEvent(GTM_EVENTS.EVALUATION_REQUEST, company);
      onCompleted(warningCode);
    },
    onError: (error) => {
      const errorCode = getErrorCodeFromExtensions(error);

      if (isCreditLineError(errorCode)) {
        const debtorNames = getDebtorNamesFromExtensions(error);
        onCreditLineError(errorCode, debtorNames);
      } else {
        addAlert({
          id: 'preoffer-request-error',
          message: 'Parece que ha ocurrido un error al enviar tus facturas para evaluación. Por favor, ponte en contacto con tu ejecutivo.',
        });
      }
    },
  });

  return {
    requestPreoffer,
    loading,
  };
};

export default useEvaluatePreoffers;
